import { Outlet } from 'react-router-dom';

const DashboardLayout = ({ children }) => {
  return children || <Outlet />
};

export default DashboardLayout;